import React from "react";
import Board from "../../../modules/board/board";
import CreativeContainer from "./index.css";

const Take = () => {
  return (
    <CreativeContainer>
      <h1>창조경영하기</h1>
      <div className="SubTitle">
        <span>창조경영를</span>
        <span className="SpecialText">하고싶어요</span>
      </div>
      <Board componentName="Take"></Board>
    </CreativeContainer>
  );
};
export default Take;
